"use client";
import styled from "styled-components";
import InnerBanner from "@/components/InnerBanner";
import { ParallaxX, ParallaxXR, splitLeft } from "../animation/TextAnimation";
import { FadeUp } from "../animations/TextAnimations";
import { usePathname } from "next/navigation";
import {Col, Container, Row} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";

export default function Privacy({ getAboutData }) {
  const pathName = usePathname();

  const getAboutDataList = getAboutData?.[0];
  const banner = getAboutDataList?.banner;


  ParallaxX(getAboutData);
  ParallaxXR(getAboutData);
  splitLeft(getAboutData);
  FadeUp(getAboutData);


  console.log(getAboutDataList?.post_content, 'getAboutDataList')

  return (
    <section>
      <InnerBanner
        data={getAboutDataList}
        img={banner?.image ? banner?.image : "/images/static/blur_.jpg"}
        subtitle={banner?.subtitle}
        title={banner?.title}
        text={banner?.desc}
      />

        <StyledMainContent className={'privacy-policy pt-100 pb-100'}>
            <Container>
                <Row>
                    <Col md={12}>
                        {reactHtmlParser(getAboutDataList?.post_content)}
                    </Col>
                </Row>
            </Container>
        </StyledMainContent>

    </section>
  );
}

const StyledMainContent = styled.section`
    h1, h2 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 600;
        color: #191919;
        text-transform: inherit;
        position: relative;
        flex-grow: 1;
        font-family: Butler;
        margin-bottom: 1rem;
    }
    h2{
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 0.5rem;
    }
    font-size: 24px;
    line-height: 32px;
    p{
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 0.75rem;
        a{
            color: #191919;
            text-decoration: underline;
            &:hover{
                color: #0055b8;
            }
        }
    }
    a{
        color: #191919;
        text-decoration: underline;
        &:hover{
            color: #0055b8;
        }
    }
    ul{
        margin-bottom: 0.75rem;
        padding-left: 30px;
        li{
            list-style-type: disc;
            font-size: 18px;
            line-height: 24px;
        }
    }
`